export default __webpack_public_path__ + "static/media/K04-Aaron.7d29bdaa.pdf";